import { useState, SyntheticEvent, useEffect } from 'react';
import WaveButtonProps from './type';
import Icon from '../Icon';
import { WaveButtonStyled, WaveDarkStyled, WaveLightStyled } from './styled';

const WaveButton = ({ onClick, ...props }: WaveButtonProps) => {
  const { endAnimation, middleAnimation, startIcon, endIcon, disabled } = props;
  const [active, setActive] = useState(false);

  const handleClick = (event: SyntheticEvent<HTMLButtonElement>) => {
    onClick(event);
    setActive(true);
  };

  useEffect(() => {
    if (!endAnimation) setActive(false);
  }, [endAnimation]);

  useEffect(() => {
    setActive(middleAnimation);
  }, [middleAnimation]);

  return (
    <WaveButtonStyled
      {...props}
      disabled={(!endAnimation && active) || disabled}
      middleAnimation={middleAnimation || active}
      onClick={handleClick}
    >
      <Icon
        style={{ position: 'absolute', zIndex: 2 }}
        styleIcon={{ transition: 'background 2s' }}
        name={startIcon || 'lockOutlined'}
        size="30px"
        color={endAnimation || active ? 'transparent' : '#0057B8'}
      />
      <Icon
        style={{ position: 'absolute', zIndex: 2 }}
        styleIcon={{ transition: 'background 2s' }}
        name={endIcon || 'lockOpenOutlined'}
        size="30px"
        color={endAnimation || active ? '#FFF' : 'transparent'}
      />
      <WaveDarkStyled className="wave-dark" />
      <WaveLightStyled className="wave-light" />
    </WaveButtonStyled>
  );
};

WaveButton.defaultProps = {
  middleAnimation: false,
};

export default WaveButton;
